import { render, staticRenderFns } from "./kzsnyyd.vue?vue&type=template&id=7f52d2a4&"
import script from "./kzsnyyd.vue?vue&type=script&lang=js&"
export * from "./kzsnyyd.vue?vue&type=script&lang=js&"
import style0 from "./kzsnyyd.vue?vue&type=style&index=0&id=7f52d2a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports